import { NavigateFunction } from "react-router-dom";

class BaseIntegration {
  meta: unknown;
  constructor(node: unknown, meta: unknown) {
    Object.assign(this, node);
    this.meta = meta;
  }

  displayName() {}

  sortName() {
    return this.displayName();
  }

  navigateTo(urlName: string | null, id: number, navigate: NavigateFunction) {
    navigate(`/app/${urlName}/integrations?id=${encodeURIComponent(id)}`);
  }

  errors(): { message: string; path?: string }[] {
    return [];
  }
}

export { BaseIntegration };
